import { ref } from 'vue'
import type { Ref } from 'vue'

export const TitleViewDetails = {
    FavoriteDetails: 'Mensagens favoritas',
    SearchMessage: 'Pesquisar mensagens',
    ViewUsersGroup: 'Ver usuários do grupo'
} as const

export type ComponentViewDetails = keyof typeof TitleViewDetails

export type DataDetails = {
    status: boolean;
    component: ComponentViewDetails
}

export interface Details {
    details: Ref<DataDetails>;
    status(): boolean;
    open(component: ComponentViewDetails): void;
    close(): void;
}

const defaultComponent = 'FavoriteDetails' as ComponentViewDetails

const details = ref({
    status: false,
    component: defaultComponent
})


export default function useViewDetails (): Details {
  function status(): boolean {
    return details.value.status
  }

  function open (component: ComponentViewDetails = defaultComponent): void {
    details.value.status = true
    details.value.component = component
  }

  function close (): void {
    details.value.status = false
    details.value.component = defaultComponent
  }

  return { status, open, close, details }
}
